export const environment = {
  orgId: 'beaubelle',
  production: false,
  apiURL:"https://www.beaubelle.in"
};
